import { Col, DatePicker, Form, Icon, Input, Row } from 'antd'
import { DeliveryMode } from '../../../../elements/DeliveryDetails'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout, rules } from '../../../../modules/FormItems'
import { dateVal } from '../../../../modules/Utils'
import React from 'react'
import { Link } from 'react-router-dom'

function MRNLinesForm(props) {
  const { line } = props
  const { getFieldDecorator, getFieldValue } = props.form

  const [PurchaseOrderSelect] = useFetchSelectUrl(
    {
      name: 'PurchaseOrder',
      url: `orders?select=_id,code,title,status&status=Approved`,
      cache: true,
      forceFetch: false,
    },
    undefined,
    undefined,
    undefined,
    (o) => ({ ...o, display: `${o.code} - ${o.title}` }),
    undefined,
    true
  )

  const purchase = (getFieldValue('purchases._id') || '').replace('purchases/', '')
  const [PurchaseLinesSelect] = useFetchSelectUrl(
    {
      name: 'purchaseLines',
      url: `orders/${purchase}/lines`,
      cache: false,
      forceFetch: true,
    },
    [purchase],
    isEmpty(purchase)
  )

  console.log({ line })
  return (
    <Form>
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Purchase Order">
            {getFieldDecorator('purchases._id', {
              initialValue: get(line, 'purchases._id'),
            })(
              <PurchaseOrderSelect
                style={{ width: purchase ? '80%' : '100%' }}
                keyAtr={'_id'}
                valueAtr={'display'}
                placeholder="Select a Purchase Order"
              />
            )}
            {purchase && (
              <Link target={'_blank'} to={`/purchasing/order/${purchase.replace('purchase/', '')}/update`}>
                <Icon style={{ marginLeft: 5 }} type="fullscreen" />
              </Link>
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Purchase Line">
            {getFieldDecorator('purchasesLines._id', {
              initialValue: get(line, 'purchasesLines._id'),
            })(<PurchaseLinesSelect keyAtr={'_id'} valueAtr={'name'} placeholder={'Purchase Line'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="No">
            {getFieldDecorator('no', {
              initialValue: get(line, 'no'),
              rules: rules.select,
            })(<Input placeholder={'No'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Delivery Date">
            {getFieldDecorator('purchasesLines.delivery.date', {
              initialValue: dateVal(line, 'purchasesLines.delivery.date'),
              rules: rules.date,
            })(<DatePicker style={{ width: '100%' }} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Delivery Method">
            {getFieldDecorator('purchasesLines.delivery.method', {
              initialValue: get(line, 'purchasesLines.delivery.method'),
              rules: rules.select,
            })(<DeliveryMode />)}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

MRNLinesForm.propTypes = {}
MRNLinesForm.defaultProps = {}

export default Form.create()(MRNLinesForm)
